import React from 'react';
import PropTypes from 'prop-types';
import autobind from 'autobind-decorator';
import QdtComponent from '../components/QdtComponent';
import GdpOverTime from '../mashup/GdpOverTime';
import GdpOverTimeMap from '../mashup/GdpOverTimeMap';
import GdpGrowth from '../mashup/GdpGrowth';
import GdpGrowthMap from '../mashup/GdpGrowthMap';
import GdpPerCapita from '../mashup/GdpPerCapita';
import GdpPerCapitaMap from '../mashup/GdpPerCapitaMap';
import ConsumerPriceIndex from '../mashup/ConsumerPriceIndex';
import PersonalIncome from '../mashup/PersonalIncome';
import FederalInterestRate from '../mashup/FederalInterestRate';
import EarningsPrivateEmployees from '../mashup/EarningsPrivateEmployees';
import NonFarmEmployees from '../mashup/NonFarmEmployees';
import InflationConsumerPrices from '../mashup/InflationConsumerPrices';
import UnemploymentRate from '../mashup/UnemploymentRate';
import UnemploymentTotal from '../mashup/UnemploymentTotal';
import HistoricalStockPrices from '../mashup/HistoricalStockPrices';

const getQueryParams = () => {
  const parentUrl = document.location.href;
  const qs = parentUrl.substr(parentUrl.indexOf('?'), parentUrl.length);
  const qsParams = {};
  if (qs && qs !== '/') {
    const qsArray = qs.split('?')[1].split('&');
    for (let i = 0; i < qsArray.length; i += 1) {
      const [key, val] = qsArray[i].split('=');
      qsParams[decodeURIComponent(key)] = decodeURIComponent(val) || true;
    }
  }
  return qsParams;
};

class Detail extends React.Component {
  static propTypes = {
    match: PropTypes.object,
  }
  static defaultProps = {
    match: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      // app: false,
      component: null,
      urlParams: getQueryParams(),
    };
    // this.getQueryParams = this.getQueryParams.bind(this);
  }

  componentWillMount() {
    this.getComponent();
  }

  componentDidMount() {
  }

  componentDidUpdate() {
  }

  componentWillUnmount() {
  }

  @autobind
  async getComponent() {
    const { urlParams } = this.state;
    const { match: { params } } = this.props;
    const selections = !!((urlParams.selections && urlParams.selections === '1'));
    const filters = !!((urlParams.filters && urlParams.filters === '1'));
    switch (params.app) {
      case 'GdpOverTime':
        this.setState({ component: <GdpOverTime filters={filters} selections={selections} /> });
        break;
      case 'GdpOverTimeMap':
        this.setState({ component: <GdpOverTimeMap filters={filters} selections={selections} /> });
        break;
      case 'GdpGrowth':
        this.setState({ component: <GdpGrowth filters={filters} selections={selections} /> });
        break;
      case 'GdpGrowthMap':
        this.setState({ component: <GdpGrowthMap filters={filters} selections={selections} /> });
        break;
      case 'GdpPerCapita':
        this.setState({ component: <GdpPerCapita filters={filters} selections={selections} /> });
        break;
      case 'GdpPerCapitaMap':
        this.setState({ component: <GdpPerCapitaMap filters={filters} selections={selections} /> });
        break;
      case 'ConsumerPriceIndex':
        this.setState({ component: <ConsumerPriceIndex filters={filters} selections={selections} /> });
        break;
      case 'PersonalIncome':
        this.setState({ component: <PersonalIncome filters={filters} selections={selections} /> });
        break;
      case 'FederalInterestRate':
        this.setState({ component: <FederalInterestRate filters={filters} selections={selections} /> });
        break;
      case 'EarningsPrivateEmployees':
        this.setState({ component: <EarningsPrivateEmployees filters={filters} selections={selections} /> });
        break;
      case 'InflationConsumerPrices':
        this.setState({ component: <InflationConsumerPrices filters={filters} selections={selections} /> });
        break;
      case 'UnemploymentRate':
        this.setState({ component: <UnemploymentRate filters={filters} selections={selections} /> });
        break;
      case 'UnemploymentTotal':
        this.setState({ component: <UnemploymentTotal filters={filters} selections={selections} /> });
        break;
      case 'HistoricalStockPrices':
        this.setState({ component: <HistoricalStockPrices filters={filters} selections={selections} /> });
        break;
      case 'NonFarmEmployees':
        this.setState({ component: <NonFarmEmployees filters={filters} selections={selections} /> });
        break;
      default:
        this.setState({ component: <GdpOverTime filters={filters} selections={selections} /> });
    }
    this.setGaEvent(params.app);
  }

  @autobind
  setGaEvent(component) {
    window.gtag('event', 'page', {
      event_category: 'Component',
      event_label: component,
    });
  }

  // <QdtComponent type="FieldApi" props={{ fields }} handleSetSelected={urlParams} />
  render() {
    const { component, urlParams } = this.state;
    // const fields = (urlParams.field1 && urlParams.field2) ? [urlParams.field1, urlParams.field2] : [urlParams.field1];
    // const selections = !!((urlParams.selections && urlParams.selections === '1'));
    const selected = (urlParams.selected) ? JSON.parse(decodeURI(urlParams.selected)) : null;
    return (
      <section id="detail">
        <QdtComponent type="SelectionApi" props={{}} handleSetSelected={selected} />
        <div className="container">
          { component }
          <div className="row pb15">
            <div className="col-12 text-right text-small">
                Source: <a href="https://www.bea.gov/iTable/index_regional.cfm">U.S. Bureau of Economic Analysis</a>
            </div>
          </div>
          <div className="row footer">
            <div className="col-md-6 clear">
              <div className="embed"><a href="https://webapps.qlik.com/financial-indicators/index.html" className=""><img src="assets/share.png" alt="share" width="12px" /> Share this visualization</a></div>

            </div>
            <div className="col-md-6 text-right">
              <div className="logo"><a href="https://www.qlik.com"><img src="assets/powered-by-Qlik-Horizontal.png" alt="logo" /></a></div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Detail;



// WEBPACK FOOTER //
// ./src/pages/Detail.jsx